import {inject, NgModule} from "@angular/core";
import {ActivatedRouteSnapshot, NoPreloading, Route, RouterModule, RouterStateSnapshot, UrlSegment} from "@angular/router";

import {AuthGuard} from "app/services/domain/auth.guard";
import {TypedRoutes} from "framework/ui/navigation/app-navigation.service";


const routes: TypedRoutes = [
    {
        path      : "",
        pathMatch : "full",
        redirectTo: "login"
    },
    {
        path        : "auth",
        loadChildren: () => import("app/authorization/authorization.module").then(m => m.AuthorizationModule)
    },
    {
        path        : "error",
        loadChildren: () => import("./error/error.module").then(m => m.ErrorModule)
    },
    {
        path        : "provider/services/report-generation",
        loadChildren: () => import("./report-generation/report-generation.module").then(m => m.ReportGenerationModule)
    },
    {
        path            : "",
        canMatch        : [
            (route: Route,
             segments: UrlSegment[]) => inject(AuthGuard)
                .canLoad(route, segments)
        ],
        canActivateChild: [
            (childRoute: ActivatedRouteSnapshot,
             state: RouterStateSnapshot) => inject(AuthGuard)
                .canActivateChild(childRoute, state)
        ],
        loadChildren    : () => import("./app.module").then(m => m.AppModule)
    },
    {
        path      : "**",
        redirectTo: "error/not-found"
    }
];

@NgModule({
              imports: [
                  RouterModule.forRoot(routes, {
                      // useHash           : true,
                      preloadingStrategy: NoPreloading
                  })
              ],
              exports: [RouterModule]
          })
export class RootRoutingModule {}
